const moveInk = (root) => {
  const tabs = root.querySelector('.ymal-tabs');
  const ink = root.querySelector('.ymal-tabs__ink');
  const active = root.querySelector('.ymal-tab[aria-selected="true"]');
  if (!tabs || !ink || !active) return;

  const tabsBox = tabs.getBoundingClientRect();
  const tabBox = active.getBoundingClientRect();
  ink.style.width = `${tabBox.width}px`;
  ink.style.transform = `translateX(${tabBox.left - tabsBox.left}px)`;
};

const reveal = (root) => {
  root.classList.add('is-inview');
  requestAnimationFrame(() => moveInk(root));
};

const bindRoot = (root) => {
  if (root.dataset.ymalBound === 'true') return;
  root.dataset.ymalBound = 'true';

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(root);
          observer.disconnect();
        });
      },
      { threshold: 0.18 }
    );
    observer.observe(root);
  } else {
    reveal(root);
  }
};

const init = () => {
  document.querySelectorAll('.ymal').forEach(bindRoot);
};

const addToCart = async (button) => {
  const variantId = button.getAttribute('data-variant-id');
  if (!variantId || button.disabled) return;
  if (typeof window.QuickAddCore?.addVariant !== 'function') return;

  button.classList.add('is-adding');
  button.disabled = true;

  try {
    await window.QuickAddCore.addVariant(variantId, 1);
    button.classList.remove('is-adding');
    button.classList.add('is-added');
    setTimeout(() => button.classList.remove('is-added'), 900);
  } catch (error) {
    console.error(error);
  } finally {
    button.disabled = false;
    button.classList.remove('is-adding');
  }
};

document.addEventListener('click', (event) => {
  const tab = event.target.closest('.ymal-tab');
  if (tab) {
    const root = tab.closest('.ymal');
    if (!root) return;
    event.preventDefault();
    const panelId = tab.getAttribute('data-panel');
    root.querySelectorAll('.ymal-tab').forEach((button) => {
      button.setAttribute('aria-selected', button === tab ? 'true' : 'false');
    });
    root.querySelectorAll('.ymal-panel').forEach((panel) => {
      const isActive = panel.getAttribute('data-panel') === panelId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-switching', isActive);
    });
    moveInk(root);
    return;
  }

  const sizeButton = event.target.closest('.ymal-size');
  if (sizeButton) {
    event.preventDefault();
    event.stopPropagation();
    if (!sizeButton.classList.contains('is-oos')) addToCart(sizeButton);
    return;
  }

  const plus = event.target.closest('.ymal-card__plus');
  if (plus) {
    event.preventDefault();
    event.stopPropagation();
    const card = plus.closest('.ymal-card');
    const hasSizes = card?.querySelector('.ymal-card__sizes');
    if (hasSizes) {
      if (window.matchMedia('(hover: none)').matches) {
        card.classList.toggle('is-sizes-open');
      }
      return;
    }
    if (plus.getAttribute('data-variant-id')) addToCart(plus);
    return;
  }

  document.querySelectorAll('.ymal-card.is-sizes-open').forEach((card) => {
    if (!card.contains(event.target)) card.classList.remove('is-sizes-open');
  });
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.ymal').forEach(moveInk);
});

init();
document.addEventListener('shopify:section:load', init);
new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
